import FoCasesModel, { FoOpenCases } from "../../../../../models/FoCloseCase";
import ActionColumnRenderer from "../../../../app/Table/renderer/ActionColumnRenderer";

export default class FoOpenCasesColumnRenderer extends ActionColumnRenderer<FoOpenCases> {
    constructor(
        renderActionColumn: (model: FoOpenCases) => JSX.Element,
        canRenderAction: (obj: any) => boolean,
        private renderInvestigator: (model: FoOpenCases) => JSX.Element
    ) {
        super(renderActionColumn, canRenderAction);
    }

    getColumns() {
        return [
            {
                name: "Claim Number",
                selector: "claimNumber",
                cell: (row: FoCasesModel) => row.getClaimNumber(),
            },
            {
                name: "Client",
                selector: "clientName",
                cell: (row: FoCasesModel) => row.getClientName(),
            },
            {
                name: "Case Type",
                selector: "caseType",
                cell: (row: FoCasesModel) => row.getCaseTypeName(),
            },
            {
                name: "Insured Name",
                selector: "insuredName",
                cell: (row: FoCasesModel) => row.getInsuredName() || "-",
            },
            {
                name: "Insured Location",
                selector: "insuredLocation",
                cell: (row: FoCasesModel) => row.getInsuredLocation() || "-",
            },
            {
                name: "Investigator",
                selector: "investigatorName",
                cell: (row: FoOpenCases) => this.renderInvestigator(row),
            },
            {
                name: "Actions",
                selector: "id",
                grow: 0,
                width: "180px",
                cell: this.renderActionColumn,
            },
        ];
    }
}